export enum UploadStatus {
    Queued = "Queued",
    InProgress = "InProgress",
    Finished = "Finished",
    Failed = "Failed"
}

export type UploadQueueItem =
    | UploadQueueItemQueued
    | UploadQueueItemInProgress
    | UploadQueueItemFinished
    | UploadQueueItemFailed

export interface UploadQueueItemQueued {
    name: string
    objectUrl: string
    status: UploadStatus.Queued
}

export interface UploadQueueItemInProgress {
    name: string
    objectUrl: string
    status: UploadStatus.InProgress
    progress: number
}

export interface UploadQueueItemFinished {
    name: string
    status: UploadStatus.Finished
    objectUrl: string
    url: string
}

export interface UploadQueueItemFailed {
    name: string
    objectUrl: string
    status: UploadStatus.Failed
    reason: string
}

export function isFinishedOrFailed(
    item: UploadQueueItem
): item is UploadQueueItemFailed | UploadQueueItemFinished {
    return (
        item.status === UploadStatus.Failed ||
        item.status === UploadStatus.Finished
    )
}

export function isQueuedOrFailed(
    item: UploadQueueItem
): item is UploadQueueItemFailed | UploadQueueItemQueued {
    return (
        item.status === UploadStatus.Failed ||
        item.status === UploadStatus.Queued
    )
}

export function isQueued(item: UploadQueueItem): item is UploadQueueItemQueued {
    return item.status === UploadStatus.Queued
}

export function isInProgress(
    item: UploadQueueItem
): item is UploadQueueItemInProgress {
    return item.status === UploadStatus.InProgress
}

export function getProgress(item: UploadQueueItem): number {
    return isInProgress(item)
        ? item.progress
        : item.status === UploadStatus.Finished
        ? 1
        : 0
}
